/* eslint-disable react/require-default-props */
/* eslint no-unused-expressions: "off" */
import { FormEventHandler } from 'react';
import { SubmitHandler, useForm, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TreeCompany, TreeGroup } from '../../../../api/model';
import Modal from '../../../modules/Modal';

type Props = {
  companyIndex: number;
  groupIndex?: number;
  open: boolean;
  onClose: () => void;
  setValue: UseFormSetValue<{ companies: TreeCompany[] }>;
  getValues: UseFormGetValues<{ companies: TreeCompany[] }>;
  /* eslint @typescript-eslint/no-explicit-any: 0 */
  append?: (params: any) => void;
};
function GroupModal({ companyIndex, groupIndex, open, onClose, setValue, getValues, append }: Props) {
  const {
    register,
    getValues: getModalValues,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<TreeGroup>({
    defaultValues: {
      group_name_ja:
        groupIndex !== undefined ? getValues(`companies.${companyIndex}.groups.${groupIndex}.group_name_ja`) : '',
      group_name_en:
        groupIndex !== undefined ? getValues(`companies.${companyIndex}.groups.${groupIndex}.group_name_en`) : '',
    },
  });
  const { t } = useTranslation();

  const handleSubmitWithoutPropagation: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    void handleSubmit(onSubmit)();
  };
  const onSubmit: SubmitHandler<TreeCompany> = () => {
    const groupNameJa = getModalValues('group_name_ja') || '';
    const groupNameEn = getModalValues('group_name_en') || '';

    if (groupIndex !== undefined) {
      setValue(`companies.${companyIndex}.groups.${groupIndex}.group_name_ja`, groupNameJa);
      setValue(`companies.${companyIndex}.groups.${groupIndex}.group_name_en`, groupNameEn);
    } else {
      append &&
        append({
          group_id: null,
          group_name_ja: groupNameJa,
          group_name_en: groupNameEn,
          hidden: 0,
        });
    }
    onClose();
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal active={open} additionalClassName="popupfr800" displayCloseButton onClose={handleClose}>
      <form onSubmit={handleSubmitWithoutPropagation}>
        <div className="popupfr pt30 popupfr644">
          <div className="teamsep2">
            <div>
              <label htmlFor="group_name_ja">{t('グループ（日）')}</label>
              <input type="text" {...register('group_name_ja', { required: true })} />
              {errors.group_name_ja?.type === 'required' && (
                <p className="errormessage show">{t('グループ（日）は必須項目です')}</p>
              )}
            </div>
            <div>
              <label htmlFor="group_name_en">{t('グループ（英）')}</label>
              <input type="text" {...register('group_name_en', { required: true })} />
              {errors.group_name_en?.type === 'required' && (
                <p className="errormessage show">{t('グループ（英）は必須項目です')}</p>
              )}
            </div>
          </div>
          <div className="btnfr btnfr2 mb0">
            <div>
              <span className="btn2 btnbg-g mr10">
                <span className="modal-close2" onClick={handleClose}>
                  {t('キャンセル')}
                </span>
              </span>
              <span>
                <input type="submit" value={t('更新').toString()} className="btn1 lsp1" />
              </span>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
export { GroupModal };
